var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c(_vm.chart,{tag:"component"}),_c('edit-chart',{attrs:{"chart-name":_vm.chart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }